(function () {
  'use strict';
  if (window.DaLucaAccessoryPDPV11) return;
  window.DaLucaAccessoryPDPV11 = true;
  const root = document.querySelector('.daluca-pdp--native-accessory');
  if (!root) return;
  const group = root.querySelector('[data-daluca-accessory-addon-group]');
  const isCareProduct = root.getAttribute('data-daluca-care-product') === 'true';
  const summary = root.querySelector('[data-daluca-accessory-cost-summary]');
  const selectionKey = 'daluca-accessory-selections-v1:' + (location.pathname.split('/products/')[1] || '').split('/')[0];
  let selections = {};
  function restoreSelections() {
    try { selections = JSON.parse(sessionStorage.getItem(selectionKey) || '{}') || {}; } catch (_) { selections = {}; }
  }
  restoreSelections();
  function remember(id, selected) {
    if (selected) selections[id] = true; else delete selections[id];
    try { sessionStorage.setItem(selectionKey, JSON.stringify(selections)); } catch (_) {}
  }
  let currentCart = null;
  let summaryKey = '';
  let variants = [];
  try { variants = JSON.parse(window.DaLucaI18n.chainText(() => (summary), [{kind:"member", optional:true, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['[data-daluca-accessory-variants]']}, {kind:"text", optional:true}]) || '[]'); } catch (_) {}
  let updatingAddon = false;
  let syncVersion = 0;
  const label = (key) => group ? group.dataset[key] || '' : '';
  const buttons = () => Array.from(root.querySelectorAll('[data-daluca-accessory-upsell]'));
  function ajaxUrl(path) {
    const base = window.Shopify?.routes?.root || window.theme?.routes?.root_url || '/';
    return String(base).replace(/\/?$/, '/') + path;
  }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:summary?.dataset.currency || label('currency') || 'USD'}).format(Number(cents || 0) / 100);
  }
  async function request(path, body) {
    const response = await fetch(ajaxUrl(path), {
      method: body ? 'POST' : 'GET',
      headers: {'Accept':'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      credentials:'same-origin', cache:'no-store',
      ...(body ? {body:JSON.stringify(body)} : {})
    });
    const data = await response.json();
    if (!response.ok || Number(data.status) >= 400) throw new Error(data.description || data.message || label('error'));
    return data;
  }
  function matchingItems(cart, id) {
    if (!cart?.items) return [];
    if (!selections[id]) return [];
    const item = (cart.items || []).find(item => String(item.variant_id) === String(id) && item.properties?.['_DaLuca care item'] === 'true' && !item.selling_plan_allocation);
    if (!item) { remember(id, false); return []; }
    return [{...item, quantity:1, final_line_price:Number(item.final_price ?? item.price), line_price:Number(item.price)}];
  }
  function setState(button, selected, busy) {
    button.disabled = busy;
    button.classList.toggle('is-busy', busy);
    button.classList.toggle('is-remove', selected);
    button.classList.remove('is-existing');
    button.setAttribute('aria-pressed', String(selected));
    button.closest('[data-daluca-accessory-addon-row]')?.classList.toggle('is-in-cart',selected);
    window.DaLucaI18n.setText(button, busy ? label(selected ? 'removing' : 'adding') : button.dataset[selected ? 'removeLabel' : 'addLabel']);
    button.removeAttribute('title');
  }
  function setStatus(message, error) {
    const node = group?.querySelector('[data-daluca-accessory-addon-status]');
    if (node) {window.DaLucaI18n.setText(node, message);node.classList.toggle('is-error',!!error);}
  }
  function updateSummary(cart) {
    if (cart?.items) currentCart = cart;
    if (!summary) return;
    const lines = summary.querySelector('[data-daluca-accessory-summary-lines]');
    const form = root.querySelector('.daluca-accessory-order-step--purchase form[action*="/cart/add"]');
    const id = form?.querySelector('[name="id"]')?.value;
    const variant = variants.find(item => String(item.id) === String(id));
    const quantity = Math.max(1, Number(form?.querySelector('[name="quantity"]')?.value) || 1);
    const base = Number(variant?.price ?? summary.dataset.basePrice);
    const data = summary.dataset;
    const selections = [], fees = [];
    root.querySelectorAll('.gpo-app input:checked,.gpo-app select').forEach(input => {
      if (input.disabled || input.closest('[hidden],.gpo-hidden') || !input.value) return;
      const labelNode = input.id && root.querySelector('label[for="'+CSS.escape(input.id)+'"]');
      const selected = input.tagName === 'SELECT' ? window.DaLucaI18n.chainText(() => (input), [{kind:"member", optional:false, computed:false, key: () => ("selectedOptions")}, {kind:"member", optional:false, computed:true, key: () => (0)}, {kind:"text", optional:true}]) : window.DaLucaI18n.chainText(() => (labelNode?.querySelector('.gpo-ov-title') || labelNode), [{kind:"text", optional:true}]) || input.value;
      const text = String(selected || '').replace(/\s+/g,' ').trim();
      if (!text || /please select|choose an option/i.test(text)) return;
      const fee = text.match(/\+\s*[^\d]*([\d,]+(?:\.\d{1,2})?)/);
      const feeSource = input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      const explicitFee = feeSource?.getAttribute('data-addon-price');
      if (explicitFee !== null && explicitFee !== undefined && Number.isFinite(Number(explicitFee))) fees.push(Math.round(Number(explicitFee)*100));
      else if (fee) fees.push(Math.round(Number(fee[1].replace(/,/g,''))*100));
      selections.push(text.replace(/\s*\(\+.*?\)\s*/g,'').trim());
    });
    const options = fees.reduce((sum,fee) => sum+fee,0);
    const rows = [];
    const row = (name,value,kind='item') => rows.push([name,value,kind]);
    row(data.productTitle, money(base));
    if (variant && variant.title !== 'Default Title' && !/^[_0-9a-f-]{20,}$/i.test(variant.title)) row(variant.title,'','selection');
    if (selections.length) row(selections.join(' · '),'','selection');
    row(data.labelQuantity, String(quantity));
    if (options) row(data.labelOptions, '+'+money(options*quantity));
    let extras = 0;
    buttons().forEach(button => {
      const items = matchingItems(currentCart,button.dataset.variantId);
      const count = items.reduce((sum,item) => sum+item.quantity,0);
      const price = items.reduce((sum,item) => sum+Number(item.final_line_price ?? item.line_price),0);
      if (!count) return;
      const name = window.DaLucaI18n.chainText(() => (button), [{kind:"member", optional:false, computed:false, key: () => ("closest")}, {kind:"call", optional:false, args: () => ['[data-daluca-accessory-addon-row]']}, {kind:"member", optional:true, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['strong']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) || button.dataset.title;
      row(name+(count>1?' × '+count:''),'+'+money(price),'addon'); extras += price;
    });
    // The selected variant is Shopify's source of truth; option surcharges are
    // separate cart lines supplied by Globo and must only be counted once.
    const pending = form?.dataset.dalucaVariantStatus === 'pending' || form?.dataset.dalucaVariantStatus === 'error' || form?.dataset.dalucaVariantStatus === 'unavailable';
    const key = JSON.stringify([rows,extras,pending]);
    if (key === summaryKey) return;
    summaryKey = key; lines.replaceChildren();
    const append = (name,value,kind) => {
      const line = document.createElement('div'); line.className='daluca-accessory-cost-summary__'+kind;
      const title = document.createElement('span'); window.DaLucaI18n.setText(title, name);
      const amount = document.createElement('strong'); window.DaLucaI18n.setText(amount, value);
      line.append(title,amount); lines.appendChild(line);
    };
    rows.filter(row=>row[2]!=='addon').forEach(row=>append(...row));
    append(data.labelExtras,extras?'':data.labelNone,'heading');
    rows.filter(row=>row[2]==='addon').forEach(row=>append(...row));
    append(data.labelTotal,pending?data.labelSelect:money((base+options)*quantity+extras),'total');
    const note=document.createElement('p'); note.className='daluca-accessory-cost-summary__note'; window.DaLucaI18n.setText(note, data.labelNote); lines.appendChild(note);
  }
  let summaryFrame = 0;
  function queueSummary() { if (!summaryFrame) summaryFrame=requestAnimationFrame(()=>{summaryFrame=0;updateSummary();}); }
  root.addEventListener('change',queueSummary);
  root.addEventListener('input',queueSummary);
  new MutationObserver(changes=>{if(changes.some(change=>!summary?.contains(change.target)))queueSummary();}).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['value','data-daluca-variant-status','checked','disabled']});
  updateSummary();
  function applyCart(cart) {
    buttons().forEach(button => setState(button,matchingItems(cart,button.dataset.variantId).length>0,false));
    document.querySelectorAll('.thb-item-count').forEach(node => {window.DaLucaI18n.setText(node, cart.item_count>99?'*':String(cart.item_count || 0));});
    updateSummary(cart);
  }
  async function syncAllAddonButtons(cart) {
    if (!group || updatingAddon) return;
    const version = ++syncVersion;
    try {
      const current = cart?.items ? cart : await request('cart.js');
      if (version === syncVersion && !updatingAddon) applyCart(current);
    } catch (_) {}
  }
  function completeAccessoryPurchase(product) {
    const id = String(product?.variant_id || product?.id || '');
    const form = root.querySelector('.daluca-accessory-order-step--purchase form[action*="/cart/add"]');
    const mainId = String(form?.querySelector('[name="id"]')?.value || '');
    if (!id || (!variants.some(variant => String(variant.id) === id) && id !== mainId)) return;
    selections = {};
    try { sessionStorage.removeItem(selectionKey); } catch (_) {}
    syncVersion++;
    buttons().forEach(button => setState(button,false,updatingAddon));
    setStatus('',false);
    updateSummary();
  }
  root.addEventListener('click', async event => {
    const button = event.target.closest('[data-daluca-accessory-upsell]');
    if (!button || !group || !root.contains(button)) return;
    event.preventDefault(); event.stopPropagation();
    if (updatingAddon || button.disabled) return;
    updatingAddon = true; syncVersion++;
    const id = button.dataset.variantId;
    const selected = button.getAttribute('aria-pressed') === 'true';
    buttons().forEach(item => {item.disabled=true;});
    setState(button,selected,true); setStatus('',false);
    try {
      const cart = await request('cart.js');
      const candidates = matchingItems(cart,id);
      const existing = candidates[0];
      if (existing) {
        const actual = (cart.items || []).find(item => item.key === existing.key);
        await request('cart/change.js',{id:existing.key,quantity:Math.max(0,Number(actual?.quantity || 1)-1)});
        remember(id, false);
      } else {
        if (!/^\d+$/.test(id)) throw new Error(label('error'));
        await request('cart/add.js',{items:[{id:Number(id),quantity:1,properties:{'_DaLuca care item':'true'}}]});
        remember(id, true);
      }
      const updated = await request('cart.js');
      updatingAddon = false; applyCart(updated);
      setStatus(label(existing ? 'removed' : 'added'),false);
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
    } catch (error) {
      updatingAddon = false;
      buttons().forEach(item=>{item.disabled=false;});
      setState(button,selected,false); setStatus(error.message || label('error'),true);
      syncAllAddonButtons();
    }
  });
  function cleanAccessoryReviews() {
    const widget = document.querySelector('.jdgm-rev-widg');
    const intro = document.querySelector('.daluca-review-intro');
    const legacyDalucaAnchor = document.getElementById('daluca-reviews');
    const legacyShopifyAnchor = document.getElementById('shopify-product-reviews');

    if (isCareProduct) {
      if (intro) {
        const introSection = intro.closest('.shopify-section');
        if (introSection) introSection.remove();
        else intro.remove();
      }
      if (widget) {
        const reviewSection = widget.closest('.shopify-section');
        if (reviewSection) reviewSection.remove();
        else widget.remove();
      }
      return false;
    }

    if (widget) {
      const reviewSection = widget.closest('.shopify-section');
      if (reviewSection) reviewSection.classList.add('daluca-accessory-reviews-section');

      let anchor = document.querySelector('.daluca-accessory-review-anchor');
      if (!anchor) {
        anchor = document.createElement('div');
        anchor.id = 'shopify-product-reviews';
        anchor.className = 'daluca-accessory-review-anchor';
        anchor.setAttribute('aria-hidden', 'true');
        widget.parentNode.insertBefore(anchor, widget);
      } else if (anchor.id !== 'shopify-product-reviews') {
        anchor.id = 'shopify-product-reviews';
      }

      let dalucaAnchor = document.getElementById('daluca-reviews');
      if (!dalucaAnchor || dalucaAnchor === anchor) {
        dalucaAnchor = document.createElement('div');
        dalucaAnchor.id = 'daluca-reviews';
        dalucaAnchor.className = 'daluca-accessory-review-anchor daluca-accessory-review-anchor--alias';
        dalucaAnchor.setAttribute('aria-hidden', 'true');
        anchor.parentNode.insertBefore(dalucaAnchor, anchor.nextSibling);
      }
    }

    [legacyDalucaAnchor, legacyShopifyAnchor].forEach(function (oldAnchor) {
      if (oldAnchor && !oldAnchor.classList.contains('daluca-accessory-review-anchor')) {
        oldAnchor.removeAttribute('id');
      }
    });

    if (intro) {
      const section = intro.closest('.shopify-section');
      if (section) section.remove();
      else intro.remove();
    }

    return !!widget;
  }

  function scrollToAccessoryReviews(event) {
    if (isCareProduct) return;
    const link = event.target.closest('a.star-rating-container[href="#shopify-product-reviews"], a.star-rating-container[href="#daluca-reviews"], a[href="#shopify-product-reviews"], a[href="#daluca-reviews"]');
    if (!link || !document.querySelector('.daluca-pdp--native-accessory')) return;

    event.preventDefault();

    let attempts = 0;
    const go = function () {
      cleanAccessoryReviews();
      const target = document.getElementById('shopify-product-reviews') ||
        document.getElementById('daluca-reviews') ||
        document.querySelector('.jdgm-rev-widg');

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      attempts += 1;
      if (attempts < 24) window.setTimeout(go, 125);
    };

    go();
  }

  document.addEventListener('click', scrollToAccessoryReviews);

  function initAccessoryReviews() {
    cleanAccessoryReviews();

    let tries = 0;
    const timer = window.setInterval(function () {
      tries += 1;
      const ready = cleanAccessoryReviews();
      if (ready || isCareProduct || tries >= 20) window.clearInterval(timer);
    }, 250);
  }

  function init() {
    const guide=root.querySelector('.daluca-gallery-guides');
    const specs=root.querySelector('.daluca-accessory-side-details__specs');
    if(guide && specs) specs.appendChild(guide);
    syncAllAddonButtons();
    initAccessoryReviews();
    // Globo inserts its option photographs after the product has loaded.
    let swatchFrame = 0;
    const sharpenSwatches = () => {
      swatchFrame = 0;
      root.querySelectorAll('.gpo-app .image-swatches img').forEach(img => {
        try {
          const source = new URL(img.currentSrc || img.src, location.href);
          if (source.hostname !== location.hostname && source.hostname !== 'cdn.shopify.com') return;
          source.searchParams.set('width', '320');
          if (img.dataset.dalucaSharpSource === source.href) return;
          img.dataset.dalucaSharpSource = source.href;
          const preload = new Image();
          preload.onload = () => {
            if (!img.isConnected) return;
            img.style.setProperty('--daluca-swatch-native-width', preload.naturalWidth + 'px');
            img.style.setProperty('--daluca-swatch-native-height', preload.naturalHeight + 'px');
            img.removeAttribute('srcset');
            img.src = source.href;
          };
          preload.src = source.href;
        } catch (_) {}
      });
    };
    const queueSwatches = () => {
      if (!swatchFrame) swatchFrame = requestAnimationFrame(sharpenSwatches);
    };
    new MutationObserver(queueSwatches).observe(root, {childList:true, subtree:true});
    sharpenSwatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('line-item:change:end', function (event) {
    syncAllAddonButtons(event.detail && event.detail.cart);
  });
  document.addEventListener('cart:item-added', function (event) {
    completeAccessoryPurchase(event.detail?.product);
    syncAllAddonButtons();
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    restoreSelections();
    syncAllAddonButtons();
  });

  document.addEventListener('cart:refresh', function () {
    window.setTimeout(syncAllAddonButtons, 250);
  });
})();




